// Twoblog.jsx (Complete English version - no shortening or deletion)
import React from 'react';
import Alert from 'react-bootstrap/Alert';
import 'bootstrap/dist/css/bootstrap.min.css';

import OneblogImg from "../../img/blog2.png";
import GymPhoto from "../../img/gymtwo.jpg";
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import './blogdetials.css'; 

function Twoblog() {
    const navigatee=useNavigate();
  
  return (
    <div className="oneblog container my-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-9">
          <article className="blog-post box shadow-sm bg-white rounded p-4 p-md-5">
            {/* Header */}
            <header className="text-center mb-5">
              <h1 className="blog-title mb-3">
                Important Medical Tips for Preventing Diseases and Enhancing General Health
              </h1>

              <div className="post-meta d-flex justify-content-center gap-4 text-muted">
                <span>April 30, 2025</span>
                <span>Health</span>
                <span>Medical Tips</span>
              </div>
            </header>

            <hr className="my-4" />

            {/* Main image */}
            <div className="text-center mb-5">
              <img
                src={OneblogImg}
                alt="Illustrative image about health and disease prevention"
                className="main-image img-fluid rounded shadow"
              />
            </div>

            {/* Introduction */}
            <section className="mb-5">
              <h2 className="section-title mb-4">
                General Medical Tips for Preventing Diseases and Promoting Health
              </h2>
              <div className="d-flex flex-column gap-4 align-items-center">
                <img
                  src={GymPhoto}
                  alt="Gym workout exercises for health"
                  className="side-image img-fluid rounded shadow mb-3 mb-md-0"
                />
                <p className="lead">
                  Disease prevention is the first step toward a long and healthy life; by adopting simple daily habits, you become able to reduce the risks of chronic diseases and maintain your quality of life and well-being. In this article, we present to you – in a professional and clear style – the most prominent general medical tips that contribute to prevention and enhancing comprehensive health.
                </p>
              </div>
            </section>

            {/* Original Benefits section (kept exactly as you had it) */}
            <section className="mb-5">
              <Alert variant="info" className="mb-4">
                <strong>The Importance of Health</strong>
              </Alert>

              <ul className="list-unstyled benefits-list">
                <li>Achieving a higher quality of life: A healthy person lives a life full of energy and happiness.</li>
                <li>Preventing diseases: A healthy lifestyle reduces the likelihood of chronic illnesses like diabetes and heart disease.</li>
                <li>Enhancing mental health: Physical health is closely linked to mental and psychological well-being.</li>
                <li>Increasing productivity: Healthy individuals are better able to accomplish tasks and stay focused daily.</li>
              </ul>
            </section>

            {/* Original Ways to Maintain Health section (kept exactly) */}
            <section className="mb-5">
              <Alert variant="success" className="mb-4">
                <strong>Ways to Maintain Health</strong>
              </Alert>

              <ol className="list-group list-group-numbered">
                <li className="list-group-item">Proper Nutrition</li>
                <li className="list-group-item">Regular Exercise</li>
                <li className="list-group-item">Adequate Sleep</li>
                <li className="list-group-item">Stress Management</li>
                <li className="list-group-item">Regular Check-ups</li>
              </ol>
            </section>

            {/* 3. Role of Healthy Food – kept 100% with all points translated */}
            <section className="mb-5">
              <Alert variant="success" className="mb-4">
                <strong>3. The Role of Healthy Nutrition</strong>
              </Alert>

              <ol className="list-group list-group-numbered">
                <li className="list-group-item">
                  Vegetables and fruits: Rich in vitamins and antioxidants that fight inflammation and strengthen immunity.
                </li>
                <li className="list-group-item">
                  Whole grains: Such as oats and quinoa to support the digestive system and provide sustainable energy.
                </li>
                <li className="list-group-item">
                  Healthy proteins: Like grilled chicken, fish, and legumes for building tissues and renewing cells.
                </li>
                <li className="list-group-item">
                  Beneficial fats: Such as olive oil and avocado to promote heart and blood vessel health.
                </li>
                <li className="list-group-item">
                  Reducing sugars and salt: Controlling sugar and salt levels protects against diabetes and high blood pressure.
                </li>
              </ol>
            </section>

            {/* 4. Importance of Regular Exercise – kept all points translated (including any overlap) */}
            <section className="mb-5">
              <Alert variant="success" className="mb-4">
                <strong>4. The Importance of Regular Exercise</strong>
              </Alert>

              <ol className="list-group list-group-numbered">
                <li className="list-group-item">
                  Daily activity: 30 minutes of brisk walking or cycling raises metabolism and improves mood.
                </li>
                <li className="list-group-item">
                  Strength exercises: Such as weight training or resistance exercises to support muscle mass and strengthen bones.
                </li>
                <li className="list-group-item">
                  Healthy proteins: Like grilled chicken, fish, and legumes for building tissues and renewing cells.
                </li>
                <li className="list-group-item">
                  Flexibility and balance: Yoga and stretching exercises reduce injuries and improve motor coordination.
                </li>
                <li className="list-group-item">
                  Reducing sugars and salt: Controlling sugar and salt levels protects against diabetes and high blood pressure.
                </li>
              </ol>
            </section>

            {/* 5. Good Sleep and Its Impact on Immunity – kept all points translated (including any overlap) */}
            <section className="mb-5">
              <Alert variant="success" className="mb-4">
                <strong>5. Good Sleep and Its Effect on Immunity</strong>
              </Alert>

              <ol className="list-group list-group-numbered">
                <li className="list-group-item">
                  7–9 hours for adults: The optimal amount of sleep supports cell renewal and strengthens the immune system.
                </li>
                <li className="list-group-item">
                  Fixed sleep routine: Going to bed and waking up at regular times helps the body regulate its biological clock.
                </li>
                <li className="list-group-item">
                  Calm sleep environment: Ensure a dark, quiet room free of electronic devices.
                </li>
                <li className="list-group-item">
                  Flexibility and balance: Yoga and stretching exercises reduce injuries and improve motor coordination.
                </li>
                <li className="list-group-item">
                  Reducing sugars and salt: Controlling sugar and salt levels protects against diabetes and high blood pressure.
                </li>
              </ol>
            </section>

            {/* Conclusion – kept your original English text */}
            <section>
              <Alert variant="primary" className="mb-4">
                <strong>Conclusion</strong>
              </Alert>

              <p className="lead fw-bold text-center">
                Health is a precious treasure that only those who lose it truly appreciate its value. By caring about daily healthy habits and monitoring our lifestyle, we can ensure a longer, happier, and more productive life.
              </p>
              <p className="text-center text-muted fst-italic">
                Always remember: A little effort today can save you a lot of suffering tomorrow.
              </p>
            </section>

            {/* Return button */}
            <div className="return">
<Link onClick={()=>navigatee(-1)} className="nav-link">                 
                <button className='btn btn-danger w-100 mt-5'>Retutn To Blog</button>
                 </Link>            </div>
          </article>
        </div>
      </div>
    </div>
  );
}

export default Twoblog;